import * as Swiper from "../libs/swiper";

export function logoSlider() {
    const isDesktop = !this.isTouch;
    let slider = $(".logo-slider .swipe-slider");

    let mySwiper = new Swiper(slider, {
        speed: 400,
        spaceBetween: 30,
        slidesPerView: "auto",
        mousewheel: isDesktop,
        slidesPerGroup: 1,
        watchOverflow: true,
        scrollbar: {
            el: ".logo-slider .scrollbar",
            draggable: true,
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/logo-slider.js